import {RosterDay} from '@/types/types';
import {Holiday} from '@cquential/api';

export default class HolidayUtil {
    public static getHolidayNamesAsSingleString(day: RosterDay, holidays: Holiday[]): string {
        return holidays
            .filter((holiday: Holiday): boolean => {
                for (const date of holiday.specialDay.dates) {
                    if (day.date.valueOf() === date.valueOf()) {
                        return true;
                    }
                }

                return false;
            })
            .map((holiday: Holiday): string => holiday.specialDay.name)
            .join(' ');
    }

    public static hasHolidays(day: RosterDay, holidays: Holiday[]): boolean {
        return holidays
            .some((holiday: Holiday): boolean => {
                for (const date of holiday.specialDay.dates) {
                    if (day.date.valueOf() === date.valueOf()) {
                        return true;
                    }
                }

                return false;
            });
    }
}
